module.exports = __webpack_public_path__ + "img/服務條款2.95aa44ae.png";